module.exports = __webpack_public_path__ + "static/img/oopvrlogo.8a9fa46.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/oopvrlogo.png
// module id = 32p9
// module chunks = 2